<input type="text" 
  [(ngModel)]="value" 
  (keydown)="handleKeyDown($event)" 
  (blur)="onChange($event)" 
  (focus)="focus($event)" />